'use client';

import type { ComponentPropsWithoutRef, MouseEvent } from 'react';
import { useRouter } from 'next/navigation';
import { useAuth } from '@/lib/auth';
import { useAuthDialog } from './AuthDialog';

type AuthTriggerProps = Omit<ComponentPropsWithoutRef<'button'>, 'type'>;

export function AuthTrigger({ children, onClick, ...rest }: AuthTriggerProps) {
  const router = useRouter();
  const { openDialog } = useAuthDialog();
  const { authed } = useAuth();

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    // Call the consumer's onClick first — useful for closing surrounding
    // panels like the mobile menu before dispatching. Runs in the same
    // event tick so the dialog / navigation fires before any unmount.
    onClick?.(event);
    if (event.defaultPrevented) return;

    // If we already have a session (or dev bypass is on), skip the
    // OAuth dialog and jump straight into the workspace.
    if (authed) {
      router.push('/app');
      return;
    }

    openDialog();
  };

  return (
    <button type="button" {...rest} onClick={handleClick}>
      {children}
    </button>
  );
}
